<template>
  <div>
    <v-carousel cycle show-arrows-on-hover>
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.src"
      ></v-carousel-item>
    </v-carousel>
    <section id="sucursales" class="my-5">
      <v-row>
        <v-col sm="12">
          <h1 class="display-3 v-heading mb-3 font-weight-light text-center">Sucursales</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="12" md="6">
          <v-img 
            :src="require('../assets/alitas.jpg')"
            aspect-ratio="1.7"
            alt="Alitas en la Mona del Astillero"
          ></v-img>
        </v-col>
        <v-col sm="12" md="6" class="hidden-sm-and-down">
          <v-row class="fill-height align-center justify-center">
            <v-col sm="12">
              <h1 class="display-1 v-heading mb-3 font-weight-light text-center">Mona del Astillero</h1>
              <p class="display-1 v-heading mb-3 font-weight-light text-center">669-981-5610</p>
              <p class="text-center">
                <v-btn icon href="https://www.facebook.com/monadelastillero" target="_black">
                  <v-icon>fab fa-facebook</v-icon>
                </v-btn>
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="text-center hidden-sm-and-up">
        <v-col sm="12">
          <h1 class="display-1 v-heading mb-3 font-weight-light text-center">Mona del Astillero</h1>
          <p class="display-1 v-heading mb-3 font-weight-light text-center">669-981-5610</p>
          <p class="text-center">
            <v-btn icon href="https://www.facebook.com/monadelastillero" target="_black">
              <v-icon>fab fa-facebook</v-icon>
            </v-btn>
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="12" md="6" class="hidden-sm-and-down">
          <v-row class="fill-height align-center justify-center">
            <v-col sm="12">
              <h1 class="display-1 v-heading mb-3 font-weight-light text-center">Mona de la Marina</h1>
              <p class="display-1 v-heading mb-3 font-weight-light text-center">669-916-0606</p>
              <p class="text-center">
                <v-btn icon href="https://www.facebook.com/monadelamarina" target="_black">
                  <v-icon>fab fa-facebook</v-icon>
                </v-btn>
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col sm="12" md="6">
          <v-img 
            :src="require('../assets/sliced-pizza.jpg')" 
            aspect-ratio="1.7"
            alt="Pizza en la Mona Marina"
          ></v-img>
        </v-col>
      </v-row>
      <v-row class="text-center hidden-sm-and-up">
        <v-col sm="12">
          <h1 class="display-1 v-heading mb-3 font-weight-light text-center">Mona de la Marina</h1>
          <p class="display-1 v-heading mb-3 font-weight-light text-center">669-916-0606</p>
          <p class="text-center">
            <v-btn icon href="https://www.facebook.com/monadelamarina" target="_black">
              <v-icon>fab fa-facebook</v-icon>
            </v-btn>
          </p>
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>

export default {
    name: 'Welcome',
    data() {
      return {
        items: [
          {
            src: require('../assets/hero1.jpg'),
          },
          {
            src: require('../assets/dos-x.jpg'),
          },
          {
            src: require('../assets/lasagna.jpg'),
          }
        ],
      }
    },
    mounted() {
        
    }
}
</script>

<style>

</style>